var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Swiper',{staticClass:"swiper_c"}),_c('homeAbout'),_c('homeProduct'),_c('homePartner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }